export const genresArr = [
  {
    id: 28,
    name: 'Action',
  },
  {
    id: 12,
    name: 'Adventure',
  },
  {
    id: 16,
    name: 'Animation',
  },
  {
    id: 35,
    name: 'Comedy',
  },
  {
    id: 80,
    name: 'Crime',
  },
  {
    id: 99,
    name: 'Documentary',
  },
  {
    id: 18,
    name: 'Drama',
  },
  {
    id: 10751,
    name: 'Family',
  },
  {
    id: 14,
    name: 'Fantasy',
  },
  {
    id: 36,
    name: 'History',
  },
  {
    id: 27,
    name: 'Horror',
  },
  {
    id: 10402,
    name: 'Music',
  },
  {
    id: 9648,
    name: 'Mystery',
  },
  {
    id: 10749,
    name: 'Romance',
  },
  {
    id: 878,
    name: 'Science Fiction',
  },
  {
    id: 10770,
    name: 'TV Movie',
  },
  {
    id: 53,
    name: 'Thriller',
  },
  {
    id: 10752,
    name: 'War',
  },
  {
    id: 37,
    name: 'Western',
  },
];

export const genresUK = [
  {
    id: 28,
    name: 'Бойовик',
  },
  {
    id: 12,
    name: 'Пригоди',
  },
  {
    id: 16,
    name: 'Мультфільм',
  },
  {
    id: 35,
    name: 'Комедія',
  },
  {
    id: 80,
    name: 'Кримінал',
  },
  {
    id: 99,
    name: 'Документальний',
  },
  {
    id: 18,
    name: 'Драма',
  },
  {
    id: 10751,
    name: 'Сімейний',
  },
  {
    id: 14,
    name: 'Фентезі',
  },
  {
    id: 36,
    name: 'Історичний',
  },
  {
    id: 27,
    name: 'Жахи',
  },
  {
    id: 10402,
    name: 'Музика',
  },
  {
    id: 9648,
    name: 'Детектив',
  },
  {
    id: 10749,
    name: 'Мелодрама',
  },
  {
    id: 878,
    name: 'Фантастика',
  },
  {
    id: 10770,
    name: 'Телефільм',
  },
  {
    id: 53,
    name: 'Трилер',
  },
  {
    id: 10752,
    name: 'Військовий',
  },
  {
    id: 37,
    name: 'Вестерн',
  },
];

